import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import {
    ExtramuralCareListComponent
} from '../../../components/services/extramural-care-list/extramural-care-list.component';

@Component({
    selector: 'app-folder-extramural-care-page',
    templateUrl: './folder-extramural-care-page.component.html',
    styleUrl: './folder-extramural-care-page.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ExtramuralCareListComponent,
    ],
})
export class FolderExtramuralCarePageComponent extends SubscriptionComponent {

    private readonly route = inject(ActivatedRoute);

    protected folderId: number = 0;

    constructor() {
        super();
        this.subs.push(
            this.route.params.subscribe((params) => {
                this.folderId = params.folderId || 0;
            }),
        );
    }

}
